import Checkbox from './Checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/index.js